module.exports = __webpack_public_path__ + "static/media/GF-logo-badge.697d8799.svg";